module.exports = __webpack_public_path__ + "media/images/feature-5-97065b94.png";